import {
    Component, Mixins,
} from 'vue-property-decorator';
import FormsMixin from '@groot-components/shared/mixins/forms/index';
import Classes from '@groot-components/shared/mixins/classes';
import config from '@groot-components/shared/config';
import direction from '@groot-nodes/helpers/direction';
import { YFieldWrapper } from '@groot-components/field-wrapper';
import Props from './props';

/**
 * @name Textarea
 */
@Component({
    components: {
        YFieldWrapper,
    },
})
class YTextarea extends Mixins(Props, Classes, FormsMixin) {
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['color', 'size', 'icon', 'sharp', 'rounded', 'flat', 'raised', 'pill', 'outline', 'bordered', 'block', 'dense'];

    /**
     * The css parent class of the component
     */
    parentClass: string = this.componentClass(this.baseClass, config.prefix.textarea);

    /**
     * Create Common Props for the textarea.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> { // eslint-disable-line @typescript-eslint/no-explicit-any
        const commonProps: Record<string, any> = { // eslint-disable-line @typescript-eslint/no-explicit-any
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            commonProps[item] = this[item];
        });
        return commonProps;
    }

    /**
     * Create classes array for the textarea.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Textarea', this.commonProps, this.baseClass || config.prefix.textarea));
        if (this.getBoolean('disabled')) {
            cls.push('is-disabled');
        }
        if (this.getBoolean('readonly')) {
            cls.push('is-readonly');
        }

        // Get Direction Class
        if (this.dir !== 'auto') {
            cls.push(`is-${this.dir}`);
        } else {
            cls.push(direction(this.model) === 'is-rtl' ? 'is-rtl' : 'is-ltr');
        }

        // Add unresizable class
        if (this.getBoolean('no_resize')) {
            cls.push('is-unresizable');
        }

        return cls;
    }
}

export default YTextarea;
